// import { createSelector } from 'kashe/reselect';
import { createSelector } from "reselect";

import { schema } from "../schema";

import type { TApplicationLog } from "@app/types/insider";

export const selectIsCollectionActive = createSelector(
  schema.applog.selectTableAsList,
  (applogArr): boolean => {
    const collections = applogArr.reduce(
      (acc, x: TApplicationLog) => {
        if (x.operation === "collection_start_editing") {
          acc.latestStart =
            acc.latestStart < x.timestamp ? x.timestamp : acc.latestStart;
        }
        if (x.operation === "collection_end_editing") {
          acc.latestEnd =
            acc.latestEnd < x.timestamp ? x.timestamp : acc.latestEnd;
        }
        return acc;
      },
      {
        latestStart: 0,
        latestEnd: 0,
      }
    );

    return collections.latestStart > collections.latestEnd;
  }
);

export const selectIsSpvMarkingInProgress = createSelector(
  schema.applog.selectTableAsList,
  (applogArr): boolean => {
    const collections = applogArr.reduce(
      (acc, x: TApplicationLog) => {
        if (x.operation === "spvlist_mark_start") {
          acc.latestStart =
            acc.latestStart < x.timestamp ? x.timestamp : acc.latestStart;
        }
        if (x.operation === "spvlist_mark_end") {
          acc.latestEnd =
            acc.latestEnd < x.timestamp ? x.timestamp : acc.latestEnd;
        }
        return acc;
      },
      {
        latestStart: 0,
        latestEnd: 0,
      }
    );

    return collections.latestStart > collections.latestEnd;
  }
);

export const selectDownloadIsInProgress = createSelector(
  schema.applog.selectTableAsList,
  (applogArr): boolean => {
    const collections = applogArr.reduce(
      (acc, x: TApplicationLog) => {
        if (x.operation === "spv_msg_start") {
          acc.latestStart =
            acc.latestStart < x.timestamp ? x.timestamp : acc.latestStart;
        }
        if (x.operation === "spv_msg_end") {
          acc.latestEnd =
            acc.latestEnd < x.timestamp ? x.timestamp : acc.latestEnd;
        }
        return acc;
      },
      {
        latestStart: 0,
        latestEnd: 0,
      }
    );

    return collections.latestStart > collections.latestEnd;
  }
);

export const processSkipForwardPersistor = createSelector(
  schema.lock.select,
  selectIsCollectionActive,
  selectIsSpvMarkingInProgress,
  selectDownloadIsInProgress,
  (
    lock,
    isCollectionActive,
    isSpvMarkingInProgress,
    isSpvMessageDownloadInProgress
  ) => {
    return (
      lock ||
      isCollectionActive ||
      isSpvMarkingInProgress ||
      isSpvMessageDownloadInProgress
    );
  }
);
